import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core'
import { StaffListItem } from 'src/app/shared/interfaces/staff/staff-list-item.interface'
import { ButtonComponent } from '../../form-elements/button/button.component'
import { RouterModule } from '@angular/router'
import { EmptyComponent } from '../../empty/empty.component'
import { StaffInlineComponent } from '../staff-inline/staff-inline.component'
import { TableModule } from '../../table/table.module'
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap'

@Component({
    selector: 'sf-staff-table',
    imports: [RouterModule, TableModule, NgbDropdownModule, ButtonComponent, StaffInlineComponent, EmptyComponent],
    templateUrl: './staff-table.component.html',
    styleUrls: ['./staff-table.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StaffTableComponent {
    @Input() staff: StaffListItem[] = []
    @Output() onUnlockAccount = new EventEmitter()
}
